"use strict";

exports.__esModule = true;
exports.DEFAULT_OPTIONS = void 0;

var _constants = require("@3nvi/gatsby-plugin-intl/constants");

const DEFAULT_OPTIONS = Object.assign({}, _constants.DEFAULT_OPTIONS, {
  i18nextConfig: {
    resources: undefined,
    fallbackLng: _constants.DEFAULT_OPTIONS.defaultLanguage,
    interpolation: {
      escapeValue: false // react already protects us from xss

    }
  }
});
exports.DEFAULT_OPTIONS = DEFAULT_OPTIONS;